import { css } from '@emotion/react';
import { useTheme } from '@mui/material';
import Colors from '../theme/colors';
import { getThemeFontColor } from '../theme/header.theme';
import { themeSelector } from '../theme/ThemeSelector';

const useHeaderStyles = () => {
  const theme = useTheme();
  return {
    tab: css({
      maxWidth: '170px',
      minWidth: '120px',
      flex: '1',
      height: '100%',
      justifyContent: 'center',
      position: 'relative',
      a: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      button: {
        width: '100%',
        height: '100%',
        padding: 0,
      },
    }),
    indicator: css({
      position: 'absolute',
      height: 8,
      width: '95%',
      margin: '0 auto',
      backgroundColor: Colors.lightTeal,
      bottom: 0,
      left: 0,
      right: 0,
      borderRadius: 8,
    }),
    hoverIndicator: css({
      position: 'absolute',
      height: 8,
      width: '95%',
      margin: '0 auto',
      backgroundColor: Colors.lightTeal,
      opacity: '0.5 !important',
      bottom: 0,
      left: 0,
      right: 0,
      borderRadius: 8,
    }),
    logoContainer: css({
      height: '100%',
      width: 78,
      [theme.breakpoints.up('lg')]: {
        width: themeSelector({
          white: 155,
          blue: 200,
        }),
      },
      zIndex: 1,
      transition: 'width 1s',
    }),
    headerlogo: css({
      marginLeft: 22,
      marginTop: 'auto',
      marginBottom: 'auto',
      paddingTop: 6,
      width: '100%',
    }),
    headerLogoLight: css({
      marginLeft: 12,
      marginTop: 'auto',
      marginBottom: 'auto',
      paddingTop: 6,
      width: '60%',
    }),
    headerK: css({
      position: 'absolute',
      left: 22,
      margin: 'auto',
      width: '100%',
    }),
  };
};

export const UserTabStyles = {
  container: css({
    marginRight: '29px',
    marginLeft: 'auto',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  menu: css({
    transform: 'translateY(-10px)',
  }),
  iconDefault: css({
    marginLeft: 13,
    fontSize: 26,
    color: Colors.white,
  }),
  userIcon: css({
    borderRadius: 30,
  }),
  logout: css({
    fontWeight: 500,
  }),
  userLabel: css({
    marginLeft: 13,
    marginRight: 7,
    fontSize: '0.875rem',
    display: 'flex',
    flexShrink: 1,
    flexWrap: 'wrap',
    whiteSpace: 'normal',
    color: getThemeFontColor(),
  }),
};

export const DrawerNavStyles = {
  header: css({
    width: '100%',
    height: '100%',
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 13,
  }),
  menu: css({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
  }),
  iconContainer: css({
    paddingTop: 14,
    paddingBottom: 66,
    paddingLeft: 6,
    backgroundColor: Colors.blue,
    width: '100%',
  }),
  userLabel: css({
    color: getThemeFontColor(),
    '& .MuiTypography-colorTextSecondary': {
      color: getThemeFontColor(),
    },
  }),
  userIcon: css({
    borderRadius: 30,
  }),
};

export const useSupportMenuStyles = () => {
  const theme = useTheme();
  return {
    button: css({
      marginRight: 7,
      fontSize: '0.875rem',
      display: 'flex',
      flexShrink: 1,
      flexWrap: 'wrap',
      whiteSpace: 'normal',
      color: getThemeFontColor(),
    }),
    paperContainer: css({
      width: 'fit-content',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: 40,
    }),
    list: css({
      '& div.MuiListItem-gutters': {
        padding: '14px 24px',
      },
    }),
    title: css({
      fontWeight: 'bold',
      marginLeft: theme.spacing(1),
    }),
    primaryIcon: css({
      backgroundColor: Colors.blue,
    }),
    secondaryIcon: css({
      backgroundColor: 'transparent',
    }),
    close: css({
      marginLeft: 'auto',
      justifySelf: 'flex-end',
    }),
  };
};

export default useHeaderStyles;
